export default "https://cdn-static.gokick.com/assets/adaefb0e3fd6b18bbcda680789a7f58b9251a870/images/spearmint-flavor.30903ab4672f84579e06d9b02d9a9cc8.png";